import React, { Component } from 'react';
/* eslint-disable no-unused-expressions */
import {
  Accordion,
  AccordionItem,
  AccordionItemButton,
  AccordionItemHeading,
  AccordionItemPanel,
} from 'react-accessible-accordion';
import 'react-accessible-accordion/dist/fancy-example.css';
import { Table } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import '../../assets/styles/DiscountCouponsList.css';
import { sess_get } from '../../utils/HttpRequests';
import AddNumberCSVModal from '../modals/AddNumberCSVModal';
import DiscountCouponUserList from './UserList';

class DicountCouponListComponent extends Component {
  constructor() {
    super();
    this.state = {
      discountCoupons: [],
      showCouponUserList: false,
      users: [],
    };
  }

  async componentDidMount() {
    const discountCoupons = await this.getDiscountCoupons();
    const state_data = this.state;
    this.setState({
      ...state_data,
      discountCoupons,
    });
  }

  getDiscountCoupons = async () => {
    const session_token = localStorage.getItem('admin-panel-sessionToken');
    return sess_get('admin/console/discount-coupon-list', session_token)
      .then((response) => response.data.response)
      .catch((error) => {
        /* eslint-disable no-console */
        console.error(error);
        return [];
      });
  };

  uploadNumbers = (id) => () => {
    this.setState({ addNumberCSVModal: id });
  };

  handleModalClose = () => {
    this.setState({ addNumberCSVModal: null });
  };

  redirectToCoupon = (id) => () => {
    const { history } = this.props;
    const path = `/discount-coupon/${id}`;
    history.push(path);
  };

  showCouponUserList = (users) => {
    const { showCouponUserList } = this.state;
    this.setState({ showCouponUserList: !showCouponUserList, users });
  };

  render() {
    const {
      showCouponUserList, users, discountCoupons, addNumberCSVModal,
    } = this.state;
    let normalDiscountCoupons = [];
    let retailPortalCoupons = [];
    const giftCoupons = [];
    let firstAnniversaryCoupons = [];
    const diwali50 = [];
    discountCoupons.map((coup) => {
      if (coup._id === 'first_anniversary') firstAnniversaryCoupons = coup.docs;
      if (coup._id === 'gift_voucher') {
        // sort discounted and normal gift vouchers
        coup.docs.forEach((item) => {
          if (item?.discount_details?.code) {
            diwali50.push(item);
          } else {
            giftCoupons.push(item);
          }
        });
      }
      if (coup._id === 'retail_portal') retailPortalCoupons = coup.docs;
      if (!coup._id || coup._id === null) normalDiscountCoupons = coup.docs;

      return coup;
    });
    return (
      <div>
        {showCouponUserList && (
          <DiscountCouponUserList
            users={users}
            showCouponUserList={this.showCouponUserList}
          />
        )}
        {!showCouponUserList && (
          <div className="discount-list-container">
            <div className="table-header">
              <div>Coupons</div>
            </div>
            <Accordion allowZeroExpanded>
              <AccordionItem key={1}>
                <AccordionItemHeading>
                  <AccordionItemButton>Discount Coupons</AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <Table className="newTable" bordered hover responsive>
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Code</th>
                        <th>User Type</th>
                        <th>Flat Discount</th>
                        <th>Discount Percentage</th>
                        <th>percentage Cap</th>
                        {/* <th>Usage Limit</th> */}
                        <th>
                          <div>Used/Limit</div>
                          <div>Pending</div>
                        </th>
                        <th>Start Date</th>
                        <th>Expiry Date</th>
                        <th>Coupon Users</th>
                        <th>Active</th>
                        <th>Care</th>
                        <th>Action</th>
                        <th>-</th>
                      </tr>
                    </thead>
                    <tbody>
                      {normalDiscountCoupons.map((item, index) => {
                        const rowno = index;
                        let user_type = 'All Users';
                        switch (item.user_type) {
                          case 'all_users':
                            user_type = 'All Users';
                            break;
                          case 'new_users':
                            user_type = 'New Users';
                            break;
                          case 'existing_users':
                            user_type = 'Existing Users';
                            break;
                          default:
                            user_type = 'All Users';
                            break;
                        }

                        return (
                          <tr key={rowno}>
                            <td>{rowno + 1}</td>
                            <td>{item.code}</td>
                            <td>{user_type}</td>
                            <td>{item.flat}</td>
                            <td>{item.percentage}</td>
                            <td>{item.percentageCap}</td>
                            <td>
                              <div>
                                {item.used || '-'}
                                /
                                {item.limit || '-'}
                              </div>
                              <div>{item.pending}</div>
                            </td>
                            <td>{item.startDate.split('T')[0]}</td>
                            <td>{item.expiryDate.split('T')[0]}</td>
                            <td
                              className="edit"
                              aria-hidden="true"
                              onClick={() => {
                                const { history } = this.props;
                                item.used && item.used > 0 && history.push(`/discount-coupon/users/${item.code}`);
                              }}
                            >
                              <a className="edit-button">
                                {(item.used && item.used > 0)
                                  ? 'Users'
                                  : '-'}
                              </a>
                            </td>
                            <td>{item.active.toString()}</td>
                            <td>{item.care_portal_enabled ? 'Yes' : '-'}</td>
                            <td
                              className="edit"
                              aria-hidden="true"
                              onClick={this.redirectToCoupon(item._id)}
                            >
                              <a className="edit-button">Edit</a>
                            </td>
                            <td
                              className="edit"
                              aria-hidden="true"
                              onClick={this.uploadNumbers(item._id)}
                            >
                              <a className="edit-button">add Numbers</a>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>
                  <AddNumberCSVModal
                    id={addNumberCSVModal}
                    show={!!addNumberCSVModal}
                    close={this.handleModalClose}
                  />
                </AccordionItemPanel>
              </AccordionItem>
            </Accordion>

            <Accordion allowZeroExpanded>
              <AccordionItem key={2}>
                <AccordionItemHeading>
                  <AccordionItemButton>Retail Coupons</AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <Table className="newTable" bordered hover responsive>
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Code</th>
                        <th>Flat Discount</th>
                        <th>Discount Percentage</th>
                        <th>percentage Cap</th>
                        {/* <th>Usage Limit</th> */}
                        <th>
                          <div>Used/Limit</div>
                          <div>Pending</div>
                        </th>
                        <th>Start Date</th>
                        <th>Expiry Date</th>
                        <th>Coupon Users</th>
                        <th>Active</th>
                        <th>Action</th>
                        <th>-</th>
                      </tr>
                    </thead>
                    <tbody>
                      {retailPortalCoupons.map((item, index) => {
                        const rowno = index;
                        return (
                          <tr key={rowno}>
                            <td>{rowno + 1}</td>
                            <td>{item.code}</td>
                            <td>{item.flat}</td>
                            <td>{item.percentage}</td>
                            <td>{item.percentageCap}</td>
                            <td>
                              <div>
                                {item.used || '-'}
                                /
                                {item.limit || '-'}
                              </div>
                              <div>{item.pending}</div>
                            </td>
                            <td>{item.startDate.split('T')[0]}</td>
                            <td>{item.expiryDate.split('T')[0]}</td>
                            <td
                              className="edit"
                              aria-hidden="true"
                              onClick={() => {
                                const { history } = this.props;
                                item.used && item.used > 0 && history.push(`/discount-coupon/users/${item.code}`);
                              }}
                            >
                              <a className="edit-button">
                                {(item.used && item.used > 0)
                                  ? 'Users'
                                  : '-'}
                              </a>
                            </td>
                            <td>{item.active.toString()}</td>
                            <td
                              className="edit"
                              aria-hidden="true"
                              onClick={this.redirectToCoupon(item._id)}
                            >
                              <a className="edit-button">Edit</a>
                            </td>
                            <td
                              aria-hidden="true"
                              className="edit"
                              onClick={this.uploadNumbers(item._id)}
                            >
                              <a className="edit-button">add Numbers</a>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>

                  <AddNumberCSVModal
                    id={addNumberCSVModal}
                    show={!!addNumberCSVModal}
                    close={this.handleModalClose}
                  />
                </AccordionItemPanel>
              </AccordionItem>
            </Accordion>

            <Accordion allowZeroExpanded>
              <AccordionItem key={3}>
                <AccordionItemHeading>
                  <AccordionItemButton>Gift Coupons</AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <Table className="newTable" bordered hover responsive>
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Code</th>
                        <th>Flat Discount</th>
                        <th>Discount Percentage</th>
                        <th>percentage Cap</th>
                        {/* <th>Usage Limit</th> */}
                        <th>
                          <div>Used/Limit</div>
                          <div>Pending</div>
                        </th>
                        <th>Start Date</th>
                        <th>Expiry Date</th>
                        <th>Coupon Users</th>
                        <th>Active</th>
                        <th>Action</th>
                        <th>-</th>
                      </tr>
                    </thead>
                    <tbody>
                      {giftCoupons.map((item, index) => {
                        const rowno = index;
                        return (
                          <tr key={rowno}>
                            <td>{rowno + 1}</td>
                            <td>{item.code}</td>
                            <td>{item.flat}</td>
                            <td>{item.percentage}</td>
                            <td>{item.percentageCap}</td>
                            <td>
                              <div>
                                {item.used || '-'}
                                /
                                {item.limit || '-'}
                              </div>
                              <div>{item.pending}</div>
                            </td>
                            <td>{item.startDate.split('T')[0]}</td>
                            <td>{item.expiryDate.split('T')[0]}</td>
                            <td
                              className="edit"
                              aria-hidden="true"
                              onClick={() => {
                                const { history } = this.props;
                                item.used && item.used > 0 && history.push(`/discount-coupon/users/${item.code}`);
                              }}
                            >
                              <a className="edit-button">
                                {(item.used && item.used > 0)
                                  ? 'Users'
                                  : '-'}
                              </a>
                            </td>
                            <td>{item.active.toString()}</td>
                            <td
                              className="edit"
                              aria-hidden="true"
                              onClick={this.redirectToCoupon(item._id)}
                            >
                              <a className="edit-button">Edit</a>
                            </td>
                            <td
                              className="edit"
                              aria-hidden="true"
                              onClick={this.uploadNumbers(item._id)}
                            >
                              <a className="edit-button">add Numbers</a>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>

                  <AddNumberCSVModal
                    id={addNumberCSVModal}
                    show={!!addNumberCSVModal}
                    close={this.handleModalClose}
                  />
                </AccordionItemPanel>
              </AccordionItem>
            </Accordion>

            <Accordion allowZeroExpanded>
              <AccordionItem key={4}>
                <AccordionItemHeading>
                  <AccordionItemButton>
                    1st Anniversary Coupons
                  </AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <Table className="newTable" bordered hover responsive>
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Code</th>
                        <th>Flat Discount</th>
                        <th>Discount Percentage</th>
                        <th>percentage Cap</th>
                        {/* <th>Usage Limit</th> */}
                        <th>
                          <div>Used/Limit</div>
                          <div>Pending</div>
                        </th>
                        <th>Start Date</th>
                        <th>Expiry Date</th>
                        <th>Coupon Users</th>
                        <th>Active</th>
                        <th>Action</th>
                        <th>-</th>
                      </tr>
                    </thead>
                    <tbody>
                      {firstAnniversaryCoupons.map((item, index) => {
                        const rowno = index;
                        return (
                          <tr key={rowno}>
                            <td>{rowno + 1}</td>
                            <td>{item.code}</td>
                            <td>{item.flat}</td>
                            <td>{item.percentage}</td>
                            <td>{item.percentageCap}</td>
                            <td>
                              <div>
                                {item.used || '-'}
                                /
                                {item.limit || '-'}
                              </div>
                              <div>{item.pending}</div>
                            </td>
                            <td>{item.startDate.split('T')[0]}</td>
                            <td>{item.expiryDate.split('T')[0]}</td>
                            <td
                              className="edit"
                              aria-hidden="true"
                              onClick={() => {
                                const { history } = this.props;
                                item.used && item.used > 0 && history.push(`/discount-coupon/users/${item.code}`);
                              }}
                            >
                              <a className="edit-button">
                                {(item.used && item.used > 0)
                                  ? 'Users'
                                  : '-'}
                              </a>
                            </td>
                            <td>{item.active.toString()}</td>
                            <td
                              className="edit"
                              aria-hidden="true"
                              onClick={this.redirectToCoupon(item._id)}
                            >
                              <a className="edit-button">Edit</a>
                            </td>
                            <td
                              className="edit"
                              aria-hidden="true"
                              onClick={this.uploadNumbers(item._id)}
                            >
                              <a className="edit-button">add Numbers</a>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>

                  <AddNumberCSVModal
                    id={addNumberCSVModal}
                    show={!!addNumberCSVModal}
                    close={this.handleModalClose}
                  />
                </AccordionItemPanel>
              </AccordionItem>
            </Accordion>

            <Accordion allowZeroExpanded>
              <AccordionItem key={3}>
                <AccordionItemHeading>
                  <AccordionItemButton>DIWALI50 Coupons</AccordionItemButton>
                </AccordionItemHeading>
                <AccordionItemPanel>
                  <Table className="newTable" bordered hover responsive>
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Code</th>
                        <th>Flat Discount</th>
                        <th>Discount Percentage</th>
                        <th>percentage Cap</th>
                        {/* <th>Usage Limit</th> */}
                        <th>
                          <div>Used/Limit</div>
                          <div>Pending</div>
                        </th>
                        <th>Start Date</th>
                        <th>Expiry Date</th>
                        <th>Coupon Users</th>
                        <th>Active</th>
                        <th>Action</th>
                        <th>-</th>
                      </tr>
                    </thead>
                    <tbody>
                      {diwali50.map((item, index) => {
                        const rowno = index;
                        if (!item.discount_details?.code) return {};
                        return (
                          <tr key={rowno}>
                            <td>{rowno + 1}</td>
                            <td>{item.code}</td>
                            <td>{item.flat}</td>
                            <td>{item.percentage}</td>
                            <td>{item.percentageCap}</td>
                            <td>
                              <div>
                                {item.used || '-'}
                                /
                                {item.limit || '-'}
                              </div>
                              <div>{item.pending}</div>
                            </td>
                            <td>{item.startDate.split('T')[0]}</td>
                            <td>{item.expiryDate.split('T')[0]}</td>
                            <td
                              className="edit"
                              aria-hidden="true"
                              onClick={() => {
                                const { history } = this.props;
                                item.used && item.used > 0 && history.push(`/discount-coupon/users/${item.code}`);
                              }}
                            >
                              <a className="edit-button">
                                {(item.used && item.used > 0)
                                  ? 'Users'
                                  : '-'}
                              </a>
                            </td>
                            <td>{item.active.toString()}</td>
                            <td
                              className="edit"
                              aria-hidden="true"
                              onClick={this.redirectToCoupon(item._id)}
                            >
                              <a className="edit-button">Edit</a>
                            </td>
                            <td
                              className="edit"
                              aria-hidden="true"
                              onClick={this.uploadNumbers(item._id)}
                            >
                              <a className="edit-button">add Numbers</a>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </Table>

                  <AddNumberCSVModal
                    id={addNumberCSVModal}
                    show={!!addNumberCSVModal}
                    close={this.handleModalClose}
                  />
                </AccordionItemPanel>
              </AccordionItem>
            </Accordion>
          </div>
        )}
      </div>
    );
  }
}

export default withRouter(DicountCouponListComponent);
